import { BrandAdToken } from "../../../models/brand.model.ts";
import { httpRequest } from "../../http";
import { brandAdTokenValuesUrl } from "./cmdGetBrandAdTokenValues";

/** The "+ Add" choices: active brand ad tokens this brand has no value for yet. */
export class CommandGetAvailableBrandAdTokens {
    async run(organizationId: string, brandId: string): Promise<BrandAdToken[]> {
        const url = `${brandAdTokenValuesUrl(organizationId, brandId)}available-ad-tokens/`;
        return await httpRequest<BrandAdToken[]>(url, { method: "GET" });
    }
}
